import type {SalesPerson} from "./type";

export const parseSalesPerson: SalesPerson = (datum) => {
    if (!datum) return;
    return {
        id: datum.get('id'),
        name: datum.get('name')
    }
}
